import LegalPage from "@/components/legal/LegalPage";

const H2 = {
  color: '#f7f7f7',
  fontSize: 18,
  fontWeight: 700,
  marginTop: 24,
  marginBottom: 10,
  letterSpacing: '0.2px'
};

const H3 = {
  color: '#f7f7f7',
  fontSize: 15,
  fontWeight: 700,
  marginTop: 20,
  marginBottom: 8,
  letterSpacing: '0.2px'
};

const A = {
  color: '#C9A86A',
  textDecoration: 'underline'
};

export default function RefundPolicy() {
  return (
    <LegalPage title="Refund Policy" testid="legal-refund">
      <>

        <h2 style={H2}>Overview</h2>
        <p>
          This Refund Policy explains when refunds may be available for purchases and
          subscriptions made through CDI Collectables. It is based on the Fees,
          cancellation rules, and consumer protection obligations set out in our SaaS
          Terms of Use.
        </p>

        <h2 style={H2}>Trial Period</h2>
        <p>
          Access to the Service is free during the initial 3‑day trial. Because no
          charges occur during the trial, refunds do not apply to this period.
        </p>

        <h2 style={H2}>Basic Account (One Off Purchase)</h2>
        <p>
          The Basic account is a one‑off fee. Refunds for Basic purchases are generally
          not provided, except where required under the New Zealand Consumer Guarantees
          Act or in cases of accidental duplicate payment.
        </p>

        <h2 style={H2}>Premium Subscription (Monthly or Annual)</h2>
        <p>Premium subscription fees are charged in advance for each Subscription Period.</p>
        <p>Refunds are generally not provided for:</p>
        <ul>
          <li>change of mind</li>
          <li>unused time</li>
          <li>partial subscription periods</li>
          <li>forgetting to cancel before renewal</li>
          <li>automatic renewals you did not intend but did not cancel in time</li>
          <li>payment failures (expired card, insufficient funds, etc.)</li>
          <li>suspension or termination caused by breach of the Terms</li>
        </ul>

        <h2 style={H2}>Fee Increases</h2>
        <p>
          If Premium subscription fees increase, you will receive at least 30 days’
          notice. If you do not wish to pay the increased fees, you may cancel your
          Premium subscription or terminate your account before the effective date.
          Refunds are not provided for Subscription Periods already paid.
        </p>

        <h2 style={H2}>Third‑Party Features</h2>
        <p>
          If a third‑party provider discontinues a feature, refunds are not provided.
        </p>

        <h2 style={H2}>When Refunds May Be Granted</h2>
        <p>Refunds may be considered in the following situations:</p>
        <ul>
          <li>accidental duplicate payments</li>
          <li>technical issues caused by CDI Collectables that prevent access to paid Premium features</li>
          <li>any situation required under the New Zealand Consumer Guarantees Act 1993</li>
        </ul>

        <h2 style={H2}>How Refunds Are Processed</h2>
        <p>
          Refunds, once approved, are processed through Stripe immediately. Most banks
          return the funds within 5–10 business days.
        </p>

        <h2 style={H2}>How to Request a Refund</h2>
        <p>
          To request a refund, email us at:{" "}
          <a style={A} href="mailto:support@cdicollectables.co.nz">
            support@cdicollectables.co.nz
          </a>
        </p>
        <p>You must submit your refund request using the same email address you used to create your CDI Collectables account.</p>

        <h3 style={H3}>Please include:</h3>
        <ul>
          <li>your name</li>
          <li>the email associated with your account</li>
          <li>the purchase or subscription date</li>
          <li>a brief explanation of the issue</li>
        </ul>

      </>
    </LegalPage>
  );
}
